
import { Component, Ref, Vue } from 'vue-property-decorator'
import LoginPage from '@/components/templates/LoginPage.vue'
import LoginMethods from '@/utils/LoginMethods'

/**
 * 生徒用ログインページ
 */
@Component({
  components: {
    LoginPage,
  },
})
export default class StudentLogin extends Vue {
  /** ログインページ */
  @Ref()
  loginPage!: LoginPage

  /**
   * パスワードリマインダページのリンク定義
   *
   * @returns 遷移先URL
   */
  private get reminderLink(): string {
    return '/student/password/reminder'
  }

  /**
   * 仮ユーザログインページのリンク定義
   *
   * @returns 遷移先URL
   */
  private get activateLink(): string {
    return '/activate/login'
  }

  /**
   * ログインボタン押下時の処理
   */
  private async eventClickLoginButton(): Promise<void> {
    const result = await this.submitLogin()
    if (result) {
      // ログイン成功時はトップページへ遷移
      this.$router.push('/student/top')
    } else {
      alert('ログインに失敗しました。')
    }
  }

  /**
   * ログインAPI
   *
   * @returns ログイン結果
   */
  private async submitLogin(): Promise<boolean | null> {
    return await LoginMethods.studentLogin(this.loginPage.loginId(), this.loginPage.password())
  }
}
